import React from "react";
import { motion } from "framer-motion";

const Partners = () => {
  // ✅ Logos from public/img
  const partners = Array.from({ length: 10 }, (_, i) => `/img/p${i + 1}.png`);

  return (
    <section className="relative py-20 sm:py-24 bg-gradient-to-b from-gray-50 to-white text-gray-900 overflow-hidden">
      {/* Decorative blur backgrounds */}
      <div className="absolute -top-10 -left-10 w-64 h-64 bg-purple-200/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-300/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800 mb-4"
        >
          Our Partners
        </motion.h2>

        <p className="text-gray-600 mb-10 sm:mb-12 text-sm sm:text-base md:text-lg max-w-xl mx-auto">
          Building strong collaborations with industry-leading organizations.
        </p>

        {/* Auto Scrolling Row */}
        <div className="overflow-hidden w-full relative">
          <motion.div
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              repeat: Infinity,
              duration: 25,
              ease: "linear",
            }}
            className="flex w-max gap-8 sm:gap-10 md:gap-12"
          >
            {/* Duplicate logos for seamless loop */}
            {partners.concat(partners).map((src, index) => (
              <div
                key={index}
                className="flex items-center justify-center
                bg-white/20 backdrop-blur-xl
                border border-white/30 shadow-lg
                rounded-2xl px-10 py-6
                min-w-[160px] sm:min-w-[200px] md:min-w-[240px]
                transition-all duration-300
                hover:bg-white/40 hover:shadow-2xl hover:scale-105"
              >
                <img
                  src={src}
                  alt={`partner-${index + 1}`}
                  className="h-14 sm:h-20 md:h-24 w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
          @keyframes pulse-slow {
            0%, 100% { opacity: 0.6; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.05); }
          }
          .animate-pulse-slow {
            animation: pulse-slow 8s ease-in-out infinite;
          }
        `}
      </style>
    </section>
  );
};

export default Partners;
